import validate from "/var/www/lottobox-agent/node_modules/nuxt/dist/pages/runtime/validate.js";
import agent_45auth_45global from "/var/www/lottobox-agent/middleware/agent-auth.global.ts";
import manifest_45route_45rule from "/var/www/lottobox-agent/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  agent_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}